module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6tTLNMwLkcW04w0sokswwg-88cf59652829d0f1597d011bf8b91b9c.jpg";